export const CHECKOUT_URL = "https://clinica.impultienda.ar/checkout/clinica";

export const MOCKUP_MAIN =
  "https://cdn.magicpatterns.com/uploads/8wdyuv9eZ62VgEZ7qHQ4S7/Diseno_sin_titulo-4.png";

export const BONO_IMAGES = {
  bono1: "https://cdn.magicpatterns.com/uploads/duU4wx47bvM2M4T7kgyKb1/BONO_1_CLINICA.png",
  bono2: "https://cdn.magicpatterns.com/uploads/7X6rpLrB6dH3dXH3JwBjMr/BONO_2_CLINICA.png",
  bono3: "https://cdn.magicpatterns.com/uploads/p8tpWBaimamkcEsZJfhsRX/BONO_3_CLINICA.png",
  bono4: "https://cdn.magicpatterns.com/uploads/6F6fg2ViPr54Ta13gGZ17X/BONO_4_CLINICA.png",
  bono5: "https://cdn.magicpatterns.com/uploads/gChs2XMM5fxVdNVzHY8f5X/BONO_5_CLINICA.png",
};

export const TESTIMONIALS = [
  {
    name: "María L.",
    country: "Colombia",
    flag: "🇨🇴",
    avatar: "https://cdn.magicpatterns.com/patterns/generated-images/c1d2e297-9d11-4fda-971b-f734b6dceda5.jpg",
    text: "Llevaba años sintiendo inseguridad al planificar rehabilitaciones completas. Hoy tengo un protocolo que me guía desde el diagnóstico hasta la ejecución.",
  },
  {
    name: "Jorge R.",
    country: "México",
    flag: "🇲🇽",
    avatar: "https://cdn.magicpatterns.com/patterns/generated-images/2b08f3b7-d731-433a-b4ce-db1ca47417ef.jpg",
    text: "El Sistema de Semáforo Clínico cambió completamente mi forma de evaluar pacientes. Ahora tomo decisiones con mucha más tranquilidad.",
  },
  {
    name: "Andrea P.",
    country: "Venezuela",
    flag: "🇻🇪",
    avatar: "https://cdn.magicpatterns.com/patterns/generated-images/04ab3044-1aba-43cb-ba4f-73de9c135b36.jpg",
    text: "El Tomo VI me ayudó a explicar mejor mis tratamientos. Mis pacientes entienden el valor del diagnóstico y aceptan con mucha más facilidad.",
  },
  {
    name: "Carlos S.",
    country: "España",
    flag: "🇪🇸",
    avatar: "https://cdn.magicpatterns.com/patterns/generated-images/91254ea1-a850-406a-ade5-3960f9c80d8c.jpg",
    text: "Los checklists se convirtieron en parte de mi rutina diaria. Me ayudan a no pasar por alto detalles importantes en cada caso.",
  },
  {
    name: "Lucía M.",
    country: "Argentina",
    flag: "🇦🇷",
    avatar: "https://cdn.magicpatterns.com/patterns/generated-images/79cbf616-b394-47eb-a202-72f8ec01d89b.jpg",
    text: "No compré unos PDFs. Compré un sistema que me ayuda a trabajar con mayor seguridad todos los días.",
  },
];

export const POPUP_BUYERS = [
  { name: "Valentina G.", country: "Colombia 🇨🇴" },
  { name: "Sebastián R.", country: "México 🇲🇽" },
  { name: "Camila F.", country: "Argentina 🇦🇷" },
  { name: "Mateo H.", country: "Chile 🇨🇱" },
  { name: "Isabella M.", country: "Perú 🇵🇪" },
  { name: "Diego L.", country: "España 🇪🇸" },
  { name: "Sofía T.", country: "Ecuador 🇪🇨" },
  { name: "Andrés V.", country: "Venezuela 🇻🇪" },
  { name: "Lucía P.", country: "Uruguay 🇺🇾" },
  { name: "Emilio C.", country: "Guatemala 🇬🇹" },
  { name: "Antonella S.", country: "Bolivia 🇧🇴" },
  { name: "Joaquín D.", country: "Costa Rica 🇨🇷" },
  { name: "Renata B.", country: "Paraguay 🇵🇾" },
  { name: "Gabriel M.", country: "República Dominicana 🇩🇴" },
  { name: "Martina Q.", country: "Panamá 🇵🇦" },
];
